import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IOnboardingGuideStep } from '../../fi-onboarding';

@Component({
    selector: 'fi-onboarding-sharing-settings-guide-card',
    templateUrl: './fi-onboarding-sharing-settings-guide-card.component.html',
    styleUrls: ['./fi-onboarding-sharing-settings-guide-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-sharing-settings-guide-card' },
    standalone: false,
})
export class FiOnboardingSharingSettingsGuideCardComponent {

    protected readonly shareTabSteps: IOnboardingGuideStep[] = [
        {
            Name: 'onboarding.share_guide_visibility',
            Description: 'onboarding.share_guide_visibility_description',
        },
        {
            Name: 'onboarding.filter_users_by_activation_date',
            Description: 'onboarding.filter_users_by_activation_date_guide_description',
        },
        {
            Name: 'onboarding.access_right_roles_heading',
            Description: 'onboarding.access_right_roles_guide_description',
        },
    ];

    protected readonly activeTabSteps: IOnboardingGuideStep[] = [
        {
            Name: 'onboarding.sharing_guide_activation_status',
            Description: 'onboarding.sharing_guide_activation_status_description',
        },
    ];
}